"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var ts_utils_1 = require("../../misc/ts-utils");
var ingredients_1 = require("../../utils/ingredients");
var Table = function (_a) {
    var _b;
    var variant = _a.variant;
    var _c = __read((0, react_1.useState)(variant), 2), selVariant = _c[0], setSelVariant = _c[1];
    var ingredientsUrl = process.env.HB_INGREDIENTS_URI;
    if (!ingredientsUrl)
        throw new Error('HB_INGREDIENTS_URI is not set');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var productDataQuery = (0, react_query_1.useQuery)(['getProductData', ingredientsUrl, selVariant === null || selVariant === void 0 ? void 0 : selVariant.sku], function () { return (0, ingredients_1.getProductData)(ingredientsUrl, selVariant.sku); }, { enabled: !!selVariant });
    var productData = (_b = productDataQuery.data) === null || _b === void 0 ? void 0 : _b.message;
    if (!selVariant) {
        return null;
    }
    // called by add-to-cart-app to change the selected and affect ingredients render in this app
    window.changeSelectedVariantForIngredients = function (selectedVariant) {
        setSelVariant(selectedVariant);
    };
    // TypeScript is not smart enough to understand that filtering undefined values produces an array where no values can be undefined, so we help it out by
    // using a simple type guard
    var ingredients = productData === null || productData === void 0 ? void 0 : productData.ingredients.filter(ts_utils_1.isTruthy);
    return (react_1.default.createElement("div", { className: 'grid-x grid-margin-x' }, ingredients === null || ingredients === void 0 ? void 0 : ingredients.map(function (ingredient, i) {
        return (react_1.default.createElement("div", { key: "ingredient-".concat(i), className: 'cell medium-6', "data-ingredient": ingredient.key },
            react_1.default.createElement("a", { className: 'display-block padding-vertical-1 margin-vertical-1 bordered border-alto', "data-accordion-menu-toggle": ingredient.key, style: { borderWidth: '0 0 1px' } },
                react_1.default.createElement("div", { className: 'flex-container align-justify align-middle text-nobel' },
                    react_1.default.createElement("div", { className: 'h7 font-bold text-uppercase' }, ingredient.ingredientName),
                    react_1.default.createElement("div", null, "+"))),
            react_1.default.createElement("div", { className: 'accordion-menu', "data-accordion-menu": ingredient.key },
                react_1.default.createElement("div", { className: 'font-lighter margin-vertical-4 h6' }, ingredient.description))));
    })));
};
var Tag = function (_a) {
    var className = _a.className, style = _a.style;
    return (react_1.default.createElement("div", { className: className, style: style }, "* Organic"));
};
/** Compound Components: https://kentcdodds.com/blog/compound-components-with-react-hooks */
var Ingredients = {
    Table: Table,
    Tag: Tag,
};
exports.default = Ingredients;
